import React from "react";
import Icon from "../../../system/components/icon";
import {useTranslate} from "../../../system/useTranslate";
import {dateToPersian} from "../../../system/utils";
import {recurrenceSummary} from "./task-recurrence-model";

/**
 * Repeat marker for a task occurrence: icon (+ optional summary), tooltip with the rule and the next occurrence,
 * and "deferred" / "skipped" labels. Renders nothing for tasks that do not repeat.
 */
export function RecurrenceBadge({task, withSummary = false, className = "text-2xs"}) {
    const translate = useTranslate();
    const series = task?.series;
    if (!series || typeof series !== "object") return null;

    const summary = recurrenceSummary(series, translate, task.scheduledDueAt);
    const nextDue = task.recurrence?.nextScheduledDueAt;
    const deferred = Boolean(task.recurrence?.isDeferred);
    const skipped = task.occurrenceStatus === "skipped";
    const paused = series.seriesStatus === "paused";

    const tooltip = [
        summary,
        nextDue ? `${translate("date-picker.recurrence.next")}: ${dateToPersian(new Date(nextDue), "dddd DD MMMM · HH:mm")}` : null,
        deferred ? translate("date-picker.recurrence.deferred") : null,
        paused ? translate("recurrence.paused") : null,
    ].filter(Boolean).join("\n");

    return (
        <span className={`inline-flex align-items-center gap-1 white-space-nowrap ${className}`} title={tooltip}>
            <Icon icon="mi mi:repeat" className="text-sm text-primary"/>
            {withSummary && <span className="text-600">{summary}</span>}
            {deferred && <span className="text-orange-600">↷ {translate("date-picker.recurrence.deferred")}</span>}
            {skipped && <span className="text-500">{translate("recurrence.skipped")}</span>}
        </span>
    );
}

export default RecurrenceBadge;
